<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import { baseProps } from '@/libs/utils/forms/baseProps.js'

export default {
  components: {
    Label
  },
  props: {
    ...baseProps,
    value: {
      type: [String, Array, Boolean, Number],
      default: null
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    opcoes: {
      type: Array,
      default: () => [{id: 0, nome: 'opção'}]
    },
    collapseTags: {
      type: Boolean,
      default: true
    },
    collapseTagsTooltip: {
      type: Boolean,
      default: true
    },
    change: {
      type: Function,
      default: () => {}
    },
    rulesInput: {
      type: String,
      default: ''
    },
    nameValidation: {
      type: String,
      default: null
    }
  },
  computed: {
    modelValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    rules () {
      return this.rulesInput
    }
  }
}

</script>

<template>
  <div>
    <validation-provider :rules="rules" v-slot="{ errors }" :name="nameValidation ? nameValidation : nomeAba + '/' + label" mode="lazy">
      <el-col :span="widthColumn" :class="marginLeft ? 'ml-forms' : ''">
        <Label :label="label" :obrigatorio="obrigatorio" :Indice="Indice" />
        <el-select
          :class="{
            'input': true,
            'select': true,
            'erro': errors.length > 0
          }"
          style="width: 100%"
          v-model="modelValue"
          @change="change"
          clearable
          filterable
          :default-first-option="false"
          :name="label"
          :multiple="multiSelect"
          no-match-text="Não encontrado, tente novamente."
          :collapse-tags="collapseTags"
          :collapse-tags-tooltip="collapseTagsTooltip"
        >
          <el-option
            v-for="opcao in opcoes"
            :key="opcao.id"
            :label="opcao.nome"
            :value="opcao.id"
            class="setFonts"
          />
        </el-select>
        <span class="help erro" v-if="errors.length > 0"> {{ errors[0] }}</span>
      </el-col>
    </validation-provider>
  </div>
</template>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';
@import '@/scss/_mixins.scss';
@import '@/scss/_typography.scss';
@import '@/scss/_utilities.scss';

.setFonts {
  [class^="el-"],
  [class*=" el-"] {
    @include set-rawline-regular;
  }
}
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/InputSelect/InputSelect.vue